import { Link } from "react-router-dom";
import { gossipItems } from "@/mocks/gossip";
import GossipCard from "@/components/feature/GossipCard";
import SectionTitle from "@/components/base/SectionTitle";

export default function FeaturedSection() {
  const [lead, ...rest] = gossipItems;
  const side = rest.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionTitle
        eyebrow="Hot Picks"
        title="热门瓜料推荐"
        desc="由编辑部根据传播速度与讨论热度挑选，从画面到时间线一次看齐。"
        moreTo="/category"
        moreLabel="浏览全部瓜料"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <article className="lg:col-span-7 group relative rounded-lg overflow-hidden border border-background-200">
          <Link to={`/article/${lead.id}`} className="block relative w-full aspect-[16/11] bg-background-200">
            <img
              src={lead.cover}
              alt={`${lead.title} 主画面`}
              title={`${lead.title} - 网曝吃瓜画面`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
          </Link>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-[11px] font-label">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              本周头条
            </span>
            <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-background-50 leading-snug">
              <Link to={`/article/${lead.id}`} className="hover:text-accent-300 transition-colors">
                {lead.title}
              </Link>
            </h3>
            <p className="hidden sm:block mt-2.5 text-sm text-background-200 leading-relaxed line-clamp-2 max-w-2xl">
              {lead.summary}
            </p>
            <div className="mt-4 flex items-center gap-4 text-xs text-background-300">
              <span className="inline-flex items-center gap-1 text-accent-300">
                <i className="ri-fire-line" aria-hidden="true"></i>
                热度 {lead.heat}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {lead.views}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                {lead.comments} 条讨论
              </span>
            </div>
          </div>
        </article>

        <div className="lg:col-span-5 flex flex-col gap-4">
          {side.map((item) => (
            <GossipCard key={item.id} item={item} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}